import { store } from '@betacrew/jars-flux'
import { PAGE_STATE } from '../../../constants/constants';

export const componentKey = "MANAGE_FORMS/MANAGE_RECONCILATION_FORM";

const { actions } = store.reducerManager.add({
    key: componentKey,
    addedReducers: {
        setLoadingState: (state, action) => {
            state.loadingState = action.payload;
        },
        setPaginationState: (state, action) => {
            state.paginationState = { ...state.paginationState, ...action.payload }
        },
        setReconciliationSelectedForms: (state, action) => {
            state.reconciliationSelectedForms = action.payload
        },
        setSelectedReconciliationFormStates: (state, action) => {
            const { name, value } = action.payload
            state.reconciliationFormStates[name] = value;
        },
        setReconciliationPayerList: (state, action) => {
            state.reconciliationPayerList = action.payload;
        },
        setReconciliationStateList: (state, action) => {
            state.reconciliationStateList = action.payload;
        },
        setReconciliationGridData: (state, action) => {
            state.reconciliationGridData = action.payload;
        },
        setBlockReconciliationModal: (state, action) => {
            state.blockReconciliationModal = action.payload;
        },
        setBlockReconciliationData: (state, action) => {
            state.blockReconciliationData = action.payload;
        },
        setBlockReconciliationSuccess: (state, action) => {
            state.blockReconciliationSuccess = action.payload
        },
        setStateWitheldPaymentFrequency: (state, action) => {
            state.stateWitheldPaymentFrequency = action.payload;
        },
        setShowStateWitheldPaymentFrequencyPopup: (state, action) => {
            state.showStateWitheldPaymentFrequencyPopup = action.payload;
        },
        setCheckForStateFrequencyPopup: (state, action) => {
            state.checkForStateFrequencyPopup = action.payload;
        },
        setSelectedStateWitheldPaymentFrequency: (state, action) => {
            state.selectedStateWitheldPaymentFrequency = action.payload;
        },
        setPayerDropdownPagination: (state, action) => {
            state.payerDropdownPagination = { ...state.payerDropdownPagination, ...action.payload }
        },
    },
    initialReducerState: {
        loadingState: { state: PAGE_STATE.PAGE_READY, message: "" },
        reconciliationSelectedForms: [],
        reconciliationFormStates: {
            ReconciliationPayer: { value: "", label: "" },
            ReconciliationTaxYear: { value: "", label: "" },
            ReconciliationState: { value: "", label: "" },
        },

        reconciliationPayerList: [],
        reconciliationStateList: [],
        reconciliationGridData: [],
        blockReconciliationData: {},

        paginationState: {
            PageNumber: 1,
            PageSize: 20,
            FilterText: "",
            IsDesc: true,
            IdNumber: "",
            Skip: 0,
            totalRecipients: 20,
        },

        payerDropdownPagination: {
            PageNumber: 1,
            PageSize: 10,
        },

        //modals
        blockReconciliationModal: false,
        stateWitheldPaymentFrequency: {},
        showStateWitheldPaymentFrequencyPopup: false,
        checkForStateFrequencyPopup: false,
        selectedStateWitheldPaymentFrequency: "",
        blockReconciliationSuccess: false
    }
})

export const { setPaginationState, setReconciliationSelectedForms, setSelectedReconciliationFormStates, setLoadingState, setReconciliationPayerList, setReconciliationStateList, setReconciliationGridData, setBlockReconciliationModal, setBlockReconciliationData, setStateWitheldPaymentFrequency, setShowStateWitheldPaymentFrequencyPopup, setCheckForStateFrequencyPopup, setSelectedStateWitheldPaymentFrequency, setBlockReconciliationSuccess, setPayerDropdownPagination } = actions; 